import { UserCRMMetadataSchema } from "@superwall-me/schema";
export const parseUser = (user)=>{
    const crmMetadata = user.crmMetadata ? UserCRMMetadataSchema.parse(user.crmMetadata) : {};
    return {
        ...user,
        crmMetadata
    };
};
